<h1>About</h1>
<p>
  Ball Score brings smart modern and affordable solutions to ball clubs and associations or federations of all levels.
</p>
<h2>Summary</h2>
<p>
  Ball Score is a web application witch autonomously generates broadcast ready computer graphics (CG) for baseball and softball
  live streams. You paste link to the game's play-by-play and graphics are ready to be added as browser layer into your
  favorite software video switcher (OBS, VMix) or playout software (CasparCG).
</p>
<p>
  As all baseball and softball games are scored in digital form, Ball Score Broadcast does not require a
  dedicated crew to operate it all the time. You can run entire broadcast with only one man to switch camera angles and comment
  on the game. Ball Score is therefore creating a more cost effective and time friendly set up and operation.
</p>
<p>
  Current version supports generating broadcast graphics for baseball and softball games scored in WBSC system MyBallClub.
  iScore compatibility broke in spring of 2023 and its support and support of GameChanger scoring system is planned to
  be based on demand of new customers.
</p>
<h2>Component examples</h2>
<app-broadcast-layer isSetup="true" [previewControls]="previewControls"></app-broadcast-layer>
<h3>Status</h3>
<p>
  This is the most important component informing the viewer about current score, count, pitch count and runners.
</p>
<p>
  The status component can be operated manually to display pitch velocity and not to be dependent on scorekeepers,
  as their input may be delayed or the scoring system may fail.
</p>
<h3>Batter</h3>
<p>
  Whenever new batter steps into a batters box, this component allows you to display his name, jersey number and
  essential hitting stats and games record in form of a lower third.
</p>
<p>
  This component can be triggered on and off by autopilot, so it is displayed after each out or first pitch or an inning.
</p>
<h3>Box score</h3>
<p>
  This component summarises runs, hits, errors and displays batters due up.
</p>
<h3>Lineup</h3>
<p>
  At beginning of every game, you want to inform the viewer about starting lineups of each team.
</p>
<h3>Defence</h3>
<p>
  This component displays the starting defence of each team in an animated modern design, including players profile
  pictures if they are set in the scoring system.
</p>
<h3>Pitcher</h3>
<p>
  If you want to display detailed stats of current pitcher on the mount, this component presents data available from
  MyBallClub scoring system.
</p>
<h3>Lower third and Custom table</h3>
<p>
  There might be another information you want to display to the viewer in same design as all other components. Lower
  third and Custom table give you all the flexibility you may need.
</p>
<p>
  Lower third lets you to select any player or coach from game team rosters, to help you to be quick and avoid
  spelling errors.
</p>
